// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "d0d12081" + "." + "4151f6d916577cc4" + ".js";
};